import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constant";

const {
  CALL_STATE,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  SELECTED_OU,
  SELECTED_BR,
  SELECTED_BR_ENTITLEMENTS,
  TARGET_BR,
  ADDED_ENT,
  DELETED_ENT,
  SOD_CONFLICTS_BR,
  CHAIN_ENTITLEMENTS,

  STEP_ONE,
  STEP_TWO,
  STEP_FOUR,
} = STATE_IDENTIFIER;

export default {
  [CALL_STATE]: IResponseState.PENDING,
  [SELECTED_BR]: null,
  [SELECTED_BR_ENTITLEMENTS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [SELECTED_OU]: null,
  [TARGET_BR]: null,
  [ADDED_ENT]: [],
  [DELETED_ENT]: [],
  [CHAIN_ENTITLEMENTS]: [],
  [STEP_ONE]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
  },
  [STEP_TWO]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
    [SOD_CONFLICTS_BR]: null,
  },
  [STEP_FOUR]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
  },
};
